<template>
  <div class="rate-view">
    <div class="grid-row">
      <div class="column">
        <h1>{{$_('my_rate')}}</h1>
        <p>{{$_('my_rate_text')}}</p>
      </div>
    </div>
    <div class="grid-row">
      <div class="column">
        <RateButton />
        <button class="btn" @click="vRateDownload">
          <span>
            <span>{{$_('i_download_my_rates')}}</span>
            <span v-if="download_loading" class="btn-loader"></span>
          </span>
        </button>
      </div>
    </div>
    <div v-if="getPnolot !== '' ">
      <RateResearch />
      <RateList />
    </div>
  </div>
</template>

<script>
import RateButton from "@/modules/tarif/components/RateButton";
import RateResearch from "@/modules/tarif/components/RateResearch";
import RateList from "@/modules/tarif/components/RateList";

import rateService from "../services/rateService";

export default {
  name: "RateView",
  components: {
    RateButton,
    RateResearch,
    RateList
  },
  data() {
    return {
      download_loading: false
    }
  },
  computed: {
    getPnolot() {
      return this.$store.getters["tarif/get_pnlot"];
    }
  },
  methods: {
    vRateDownload() {

      this.download_loading = true;

      let pnocl = this.$store.getters['tarif/get_pnlot'];

      if(pnocl === '') {
        rateService.getRate()
        .then(res => {
          if(res.data.POK !== 0) {
            rateService.getRateDownload(res.data.PNLOT)
            .then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'tarifs.pdf');
              document.body.appendChild(link);
              link.click();

              this.download_loading = false;
            })
          }
        });
      } else {
        rateService.getRateDownload(this.$store.getters['tarif/get_pnlot'])
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'tarifs.pdf');
          document.body.appendChild(link);
          link.click();

          this.download_loading = false;
        })
      }
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 0px;
}
.btn-loader {
  width: 15px;
  height: 15px;
  border: solid 2px #fff;
  border-radius: 50%;
  display: inline-block;
  border-bottom-color: transparent;
  animation: rotate 0.6s infinite linear;
  margin-left: 15px;
}
.btn span {
  display: flex;
  align-items: center;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 800px) {
  .btn-rate-generation {
    margin-bottom: 10px;
  }
}
</style>